import React, { FunctionComponent } from 'react';
import { Button, ButtonProps } from '@ds/ui';
import { useHistory } from 'react-router-dom';

import { TranslationContext } from '@ds/react-utils';

const ContainerLayoutFooterSecondaryButton: FunctionComponent<ButtonProps> = props => {
    const history = useHistory();
    const translate = React.useContext(TranslationContext);

    return (
        <Button
            onClick={history.goBack}
            kind="tertiary"
            size="small"
            data-qa="sticky-button-secondary"
            text={translate('button-back-titlecase')}
            {...props}
        />
    );
};

export default ContainerLayoutFooterSecondaryButton;
